import {
  KYC_DOC_LIST_FAILED,
  KYC_DOC_LIST_INVALID_REQUEST,
  KYC_DOC_LIST_SUCCESS,
  RESET_KYC_DOC_LIST,
  RESET_GET_KYC_DETAILS,
  GET_KYC_DETAILS_SUCCESS,
  KYC_DOC_LIST_LOADING,
  LOAD_LIMIT_SUCCESS,
  UPGRADE_WALLET_SUCCESS,
  // LOGIN_SUCCESS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  data: [],
  levels: [
    { isUpgraded: false, levelName: "standard" },
    { isUpgraded: false, levelName: "premium" },
    { isUpgraded: false, levelName: "supreme" },
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case KYC_DOC_LIST_LOADING:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
      };
    case KYC_DOC_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        networkError: "",
        data: action.payload,
      };

    case KYC_DOC_LIST_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        networkError: "",
        data: action.payload,
      };

    case KYC_DOC_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };
    }

    case GET_KYC_DETAILS_SUCCESS: {
      console.log(action.payload[0].kycDetails);
      if (action.payload[0].kycDetails) {
        const actions = [].concat(action.payload[0].kycDetails).reduce(
          (acc, curr) => ({
            ...acc,
            [curr.kycAction]: curr || "",
          }),
          {}
        );

        console.log(actions);

        const [
          standardDocTypes,
          premiumDocTypes,
          supremeDocTypes,
          companyDocTypes,
        ] = Object.values(state.data[0].kycList).map((obj) =>
          []
            .concat(obj.DocTypeList)
            .filter(Boolean)
            .map((x) =>
              x.proofType in actions
                ? { ...x, status: actions[x.proofType].status }
                : x
            )
        );

        const nextState = state.data.map((obj) => ({
          ...obj,
          kycDocList: {
            ...obj.kycDocList,
            standard: {
              ...obj.kycDocList.standard,
              DocTypeList: standardDocTypes,
            },
            premium: {
              ...obj.kycDocList.premium,
              DocTypeList: premiumDocTypes,
            },
            supreme: {
              ...obj.kycDocList.supreme,
              DocTypeList: supremeDocTypes,
            },
            companyDocs: {
              ...obj.kycDocList.companyDocs,
              DocTypeList: companyDocTypes,
            },
          },
        }));

        return {
          ...state,
          data: nextState,
        };
      }

      return state;
    }

    case LOAD_LIMIT_SUCCESS: {
      if (state.data.length) {
        const [standardDocTypes, premiumDocTypes, supremeDocTypes] =
          Object.entries(state.data[0].kycDocList).map(([key, value]) =>
            key in action.payload[0]
              ? { ...value, limits: action.payload[0][key] }
              : value
          );

        const nextState = state.data.map((obj) => ({
          ...obj,
          kycDocList: {
            ...obj.kycDocList,
            standard: standardDocTypes,
            premium: premiumDocTypes,
            supreme: supremeDocTypes,
          },
        }));

        return {
          ...state,
          data: nextState,
        };
      }

      return state;
    }

    // case LOGIN_SUCCESS: {
    //   const index = state.levels.findIndex(
    //     (l) => l.levelName.toUpperCase() === action.data.kycAccountType
    //   );

    //   return {
    //     ...state,
    //     levels: state.levels.map((l, i) =>
    //       i <= index ? { ...l, isUpgraded: true } : l
    //     ),
    //   };
    // }

    case UPGRADE_WALLET_SUCCESS: {
      const index = Object.entries(state.data[0].kycList).findIndex(
        ([, value]) => value.kYCLevelName === action.payload.levelName
      );

      return {
        ...state,
        levels: state.levels.map((l, i) =>
          i <= index ? { ...l, isUpgraded: true } : l
        ),
      };
    }

    case RESET_GET_KYC_DETAILS:
      {
        if (state.data.length) {
          const [
            standardDocTypes,
            premiumDocTypes,
            supremeDocTypes,
            companyDocTypes,
          ] = Object.values(state.data[0].kycDocList).map((obj) =>
            []
              .concat(obj.DocTypeList)
              .filter(Boolean)
              .map((x) => ({ ...x, status: "" }))
          );

          const nextState = state.data.map((obj) => ({
            ...obj,
            kycDocList: {
              ...obj.kycDocList,
              standard: {
                ...obj.kycDocList.standard,
                DocTypeList: standardDocTypes,
              },
              premium: {
                ...obj.kycDocList.premium,
                DocTypeList: premiumDocTypes,
              },
              supreme: {
                ...obj.kycDocList.supreme,
                DocTypeList: supremeDocTypes,
              },
              companyDocs: {
                ...obj.kycDocList.companyDocs,
                DocTypeList: companyDocTypes,
              },
            },
          }));
          return {
            ...state,
            data: nextState,
          };
        }
      }

      return state;

    // case NETWORK_ERROR_UPGRADE_WALLET:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     failed: false,
    //     success: false,
    //     invalidRequest: false,
    //     networkError: "Something went wrong.."
    //   };

    case RESET_KYC_DOC_LIST:
      return (state = initialState);

    default:
      return state;
  }
};
